import {
    Card,
} from "react-bootstrap";
import React from "react";
import DentistCard from './one_card/dentist_card';

export default function DentistCards(props) {
    const dentists = props.dentists;
        return (
            <div>
                <Card className="card">
                    <Card.Header>Best rated of 2020</Card.Header>

                    <Card.Body>
                        <Card.Text>
                        Here is the definitive list of UAE's dentists as rated by the UAE
                        community. These dentists have received great reviews from
                        customers and are currently accepting new patients. Schedule your
                        appointment today!
                        </Card.Text>
                    </Card.Body>
                </Card>
            {(dentists.map(dentist => (
                    <DentistCard key={dentist._id} dentist={dentist}/>
                ))
                )}
          </div>
        );
      }
    